import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/onboarding/_blank')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="container mx-auto">
      <div className="w-full">
        <Outlet />
      </div>
    </div>
  )
}
